var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5491 5L7.79906 1.25M7.79906 1.25L4.04906 5M7.79906 1.25L7.79906 10.25M11.5491 8C11.7707 8 11.8816 8 11.9776 8.00824C12.9755 8.09388 13.7967 8.82886 13.992 9.81122C14.0108 9.90573 14.0231 10.016 14.0475 10.2362L14.1326 11.0023C14.2605 12.1531 14.3245 12.7286 14.1782 13.1858C13.9831 13.7953 13.5377 14.2929 12.9534 14.5541C12.5152 14.75 11.9362 14.75 10.7783 14.75L4.81983 14.75C3.66188 14.75 3.08291 14.75 2.6447 14.5541C2.06042 14.2929 1.61501 13.7953 1.41995 13.1858C1.27366 12.7286 1.3376 12.1532 1.46547 11.0023L1.55059 10.2362C1.57507 10.0159 1.58731 9.90575 1.6061 9.81122C1.80142 8.82886 2.62259 8.09388 3.62051 8.00824C3.71653 8 3.82737 8 4.04906 8",
    stroke: "#636874",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportGrey);
export default __webpack_public_path__ + "static/media/export-grey.d02012a2e075b75df2eee46eca53fd21.svg";
export { ForwardRef as ReactComponent };